import React from "react";
import { observer } from "mobx-react-lite";
import { IResourceFormData } from "./interface";

import DrainageForm from "./data/drainageForm/drainageForm";
import LightingForm from "./data/lightingForm/lightingForm";
import HeatSupplyForm from "./data/heatSupplyForm/heatSupplyForm";
import PowerSupplyForm from "./data/powerSupplyForm/powerSupplyForm";
import ColdWaterSupplyForm from "./data/coldWaterSupplyForm/coldWaterSupplyForm";
import GasCommunicationForm from "./data/gasCommunicationForm/gasCommunicationForm";

import {
  HEAT_SUPPLY_KEY,
  COLD_WATER_SUPPLY_KEY,
  GAS_COMMUNICATION_KEY,
  LIGHING_KEY,
  DRAINAGE_KEY,
  POWER_SUPPLY_KEY,
} from "./constants";

const ResourceFormData: React.FC<IResourceFormData> = observer(
  ({
    formId,
    isAddMode,
    isClose,
    isReadonly,
    onChangeImage,
    setAddressInfo,
    data,
    RSOList,
    ...handleForm
  }) => {
    switch (formId) {
      case HEAT_SUPPLY_KEY:
        return (
          <HeatSupplyForm
            formId={formId}
            isClose={isClose}
            isAddMode={isAddMode}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            isReadonly={isReadonly}
            {...handleForm}
          />
        );
      case COLD_WATER_SUPPLY_KEY:
        return (
          <ColdWaterSupplyForm
            formId={formId}
            isClose={isClose}
            isAddMode={isAddMode}
            isReadonly={isReadonly}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            {...handleForm}
          />
        );
      case GAS_COMMUNICATION_KEY:
        return (
          <GasCommunicationForm
            isAddMode={isAddMode}
            isClose={isClose}
            isReadonly={isReadonly}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            {...handleForm}
          />
        );
      case LIGHING_KEY:
        return (
          <LightingForm
            isAddMode={isAddMode}
            isClose={isClose}
            isReadonly={isReadonly}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            {...handleForm}
          />
        );
      case DRAINAGE_KEY:
        return (
          <DrainageForm
            formId={formId}
            isAddMode={isAddMode}
            isClose={isClose}
            isReadonly={isReadonly}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            {...handleForm}
          />
        );
      case POWER_SUPPLY_KEY:
        return (
          <PowerSupplyForm
            isAddMode={isAddMode}
            isClose={isClose}
            isReadonly={isReadonly}
            onChangeImage={onChangeImage}
            setAddressInfo={setAddressInfo}
            data={data}
            RSOList={RSOList}
            {...handleForm}
          />
        );
      default:
        return null;
    }
  },
);

export default ResourceFormData;
